import React, { useRef, useState, useEffect, useCallback } from 'react';
import '../styles/gallery.css';

// Import bar images
import bar1 from '../assets/images/Blue_Bar_1.jpg';
import bar2 from '../assets/images/Blue_Bar_2.jpg';
import dining1 from '../assets/images/Blue_Bar_3.jpg';
import dining2 from '../assets/images/Blue_Bar_4.jpg';
import dining3 from '../assets/images/Blue_Bar_5.jpg';

const images = [bar1, bar2, dining1, dining2, dining3];

const BarGallery = ({ language }) => {
  const scrollRef = useRef(null);
  const [modalImageIndex, setModalImageIndex] = useState(null);

  const scroll = (dir) => {
    scrollRef.current.scrollBy({ left: dir === 'left' ? -400 : 400, behavior: 'smooth' });
  };

  const openModal = (index) => {
    setModalImageIndex(index);
  };

  const closeModal = () => {
    setModalImageIndex(null);
  };

  const prev = useCallback(() => {
    if (modalImageIndex !== null) {
      setModalImageIndex((modalImageIndex - 1 + images.length) % images.length);
    }
  }, [modalImageIndex]);

  const next = useCallback(() => {
    if (modalImageIndex !== null) {
      setModalImageIndex((modalImageIndex + 1) % images.length);
    }
  }, [modalImageIndex]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (modalImageIndex !== null) {
        if (e.key === 'ArrowLeft') prev();
        if (e.key === 'ArrowRight') next();
        if (e.key === 'Escape') closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [modalImageIndex, prev, next]);

  return (
    <section className="gallery-wrapper py-5 bg-dark text-white">
      <div className="container">
        <h2 className="fw-bold mb-4 text-center text-white">
          {language === 'am' ? 'የብሉ ኔስት ሆቴል ባር እና ሬስቶራንት ጋለሪ' : 'Blue Nest Hotel Bar & Restaurant Gallery'}
        </h2>
        <div className="gallery-scroll-wrapper">
          <button className="scroll-btn left" onClick={() => scroll('left')}>&lt;</button>
          <div className="gallery-scroll" ref={scrollRef}>
            {images.map((img, i) => (
              <div className="gallery-image-wrapper" key={i} onClick={() => openModal(i)}>
                <img src={img} className="gallery-image" alt={`Blue Nest Hotel Bar & Restaurant ${i + 1}`} />
              </div>
            ))}
          </div>
          <button className="scroll-btn right" onClick={() => scroll('right')}>&gt;</button>
        </div>
      </div>

      {modalImageIndex !== null && (
        <div className="image-modal" onClick={closeModal}>
          <img 
            src={images[modalImageIndex]} 
            className="modal-img" 
            alt="Blue Nest Hotel Bar & Restaurant Preview" 
            onClick={(e) => e.stopPropagation()}
          />
          <button className="close-btn" onClick={closeModal}>×</button>
          <button className="nav-btn prev-btn" onClick={(e) => { e.stopPropagation(); prev(); }}>‹</button>
          <button className="nav-btn next-btn" onClick={(e) => { e.stopPropagation(); next(); }}>›</button>
        </div>
      )}
    </section>
  );
};

export default BarGallery;
